import React, { useState } from 'react';
import { useFirebase } from '../../context/firebaseContext';
import { signInWithEmailAndPassword } from 'firebase/auth';
import { useNavigate } from 'react-router-dom';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelope, faLock, faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';

const LoginMobile = () => {
    const { auth } = useFirebase();
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState(null);
    const [showPassword, setShowPassword] = useState(false);
    const [rememberMe, setRememberMe] = useState(false);
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    const getErrorMessage = (code) => {
        switch (code) {
            case 'auth/wrong-password':
                return 'Password is incorrect. Try again or reset it if you\'ve forgotten.';
            case 'auth/user-not-found':
                return 'No account exists with that email. Double-check or create one.';
            case 'auth/invalid-email':
                return 'That email doesn\'t look valid. Please update it and try again.';
            default:
                return 'Login failed. Please check your credentials and try again.';
        }
    };

    const handleLogin = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError(null);

        try {
            await signInWithEmailAndPassword(auth, email, password);
            navigate('/mobile/profile'); // Redirect to mobile profile
        } catch (error) {
            console.error('Login error:', error.message);
            setError(getErrorMessage(error?.code));
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="mobile-login-container">
            <div className="mobile-login-card">
                <div className="mobile-login-header">
                    <h1 className="mobile-login-title">Welcome Back</h1>
                    <p className="mobile-login-subtitle">Sign in to your account</p>
                </div>

            <form onSubmit={handleLogin} className="mobile-login-form">
                {/* Email Field with Floating Label and Icon */}
                <div className="mobile-form-group">
                    <div className="control has-icons-left" style={{ position: 'relative' }}>
                        <input
                            className="mobile-form-input"
                            type="email"
                            id="email"
                            placeholder="Enter your email address"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            required
                            style={{
                                paddingLeft: '2.5rem',
                                paddingRight: '1rem',
                                border: '1px solid rgba(255, 215, 0, 0.3)',
                                borderRadius: '8px',
                                transition: 'all 0.3s ease',
                                background: 'rgba(255, 255, 255, 0.05)',
                                backdropFilter: 'blur(10px)',
                                color: 'white',
                                fontSize: '0.875rem'
                            }}
                            onFocus={(e) => {
                                e.target.style.borderColor = '#FFD700';
                                e.target.style.boxShadow = '0 0 0 2px rgba(255, 215, 0, 0.2)';
                            }}
                            onBlur={(e) => {
                                e.target.style.borderColor = 'rgba(255, 215, 0, 0.3)';
                                e.target.style.boxShadow = 'none';
                            }}
                        />
                        <span style={{
                            position: 'absolute',
                            left: '0.7rem',
                            top: '50%',
                            transform: 'translateY(-50%)',
                            color: '#FFD700',
                            zIndex: 2
                        }}>
                            <FontAwesomeIcon icon={faEnvelope} style={{ fontSize: '16px' }} />
                        </span>
                    </div>
                </div>

                {/* Password Field with Floating Label and Icon */}
                <div className="mobile-form-group">
                    <div className="control has-icons-left" style={{ position: 'relative' }}>
                        <input
                            className="mobile-form-input"
                            type={showPassword ? 'text' : 'password'}
                            id="password"
                            placeholder="Enter your password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            required
                            style={{
                                paddingLeft: '2.5rem',
                                paddingRight: '2.5rem',
                                border: '1px solid rgba(255, 215, 0, 0.3)',
                                borderRadius: '8px',
                                transition: 'all 0.3s ease',
                                background: 'rgba(255, 255, 255, 0.05)',
                                backdropFilter: 'blur(10px)',
                                color: 'white',
                                fontSize: '0.875rem',
                                animation: showPassword ? 'passwordReveal 0.3s ease' : 'passwordHide 0.3s ease'
                            }}
                            onFocus={(e) => {
                                e.target.style.borderColor = '#FFD700';
                                e.target.style.boxShadow = '0 0 0 2px rgba(255, 215, 0, 0.2)';
                            }}
                            onBlur={(e) => {
                                e.target.style.borderColor = 'rgba(255, 215, 0, 0.3)';
                                e.target.style.boxShadow = 'none';
                            }}
                        />
                        <span style={{
                            position: 'absolute',
                            left: '0.7rem',
                            top: '50%',
                            transform: 'translateY(-50%)',
                            color: '#FFD700',
                            zIndex: 2
                        }}>
                            <FontAwesomeIcon icon={faLock} style={{ fontSize: '16px' }} />
                        </span>
                        <button
                            type="button"
                            onClick={() => setShowPassword(!showPassword)}
                            style={{
                                position: 'absolute',
                                right: '0.7rem',
                                top: '50%',
                                transform: 'translateY(-50%)',
                                background: 'rgba(255, 215, 0, 0.1)',
                                border: '1px solid rgba(255, 215, 0, 0.2)',
                                borderRadius: '6px',
                                color: '#FFD700',
                                cursor: 'pointer',
                                zIndex: 2,
                                padding: '0.5rem',
                                transition: 'all 0.3s ease',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                minWidth: '32px',
                                minHeight: '32px'
                            }}
                            onMouseEnter={(e) => {
                                e.target.style.background = 'rgba(255, 215, 0, 0.2)';
                                e.target.style.borderColor = 'rgba(255, 215, 0, 0.4)';
                                e.target.style.transform = 'translateY(-50%) scale(1.05)';
                                e.target.style.boxShadow = '0 2px 8px rgba(255, 215, 0, 0.3)';
                            }}
                            onMouseLeave={(e) => {
                                e.target.style.background = 'rgba(255, 215, 0, 0.1)';
                                e.target.style.borderColor = 'rgba(255, 215, 0, 0.2)';
                                e.target.style.transform = 'translateY(-50%) scale(1)';
                                e.target.style.boxShadow = 'none';
                            }}
                            onMouseDown={(e) => {
                                e.target.style.transform = 'translateY(-50%) scale(0.95)';
                                e.target.style.background = 'rgba(255, 215, 0, 0.3)';
                            }}
                            onMouseUp={(e) => {
                                e.target.style.transform = 'translateY(-50%) scale(1.05)';
                                e.target.style.background = 'rgba(255, 215, 0, 0.2)';
                            }}
                            title={showPassword ? "Hide password" : "Show password"}
                        >
                            <FontAwesomeIcon 
                                icon={showPassword ? faEyeSlash : faEye} 
                                style={{ 
                                    fontSize: '14px',
                                    transition: 'all 0.3s ease',
                                    transform: showPassword ? 'rotate(0deg)' : 'rotate(0deg)'
                                }} 
                            />
                        </button>
                    </div>
                </div>

                {/* Remember Me Checkbox */}
                <div className="mobile-form-group">
                    <div className="control">
                        <label className="checkbox has-text-warning" style={{ fontSize: '0.9rem', color: 'rgba(255, 255, 255, 0.8)' }}>
                            <input
                                type="checkbox"
                                checked={rememberMe}
                                onChange={(e) => setRememberMe(e.target.checked)}
                                style={{ marginRight: '0.5rem' }}
                            />
                            Remember me
                        </label>
                    </div>
                </div>

                {/* Error Message */}
                {error && (
                    <div className="auth-alert is-error" role="alert" style={{ marginBottom: '1rem' }}>
                        <div className="auth-alert__icon" aria-hidden="true">!</div>
                        <div className="auth-alert__content">
                            <div className="auth-alert__title">Password issue</div>
                            <div className="auth-alert__text">{error}</div>
                        </div>
                    </div>
                )}

                {/* Submit Button */}
                <div className="mobile-form-group">
                    <div className="control">
                        <button
                            type="submit"
                            className="mobile-login-button"
                            disabled={loading}
                            style={{
                                background: 'linear-gradient(135deg, #FFD700, #FFA500)',
                                border: 'none',
                                borderRadius: '8px',
                                padding: '0.75rem 1.5rem',
                                fontSize: '1rem',
                                fontWeight: '600',
                                transition: 'all 0.3s ease',
                                boxShadow: '0 4px 15px rgba(255, 215, 0, 0.3)',
                                color: 'var(--mobile-contrast)',
                                width: '100%',
                                cursor: 'pointer'
                            }}
                            onMouseEnter={(e) => {
                                e.target.style.transform = 'translateY(-2px)';
                                e.target.style.boxShadow = '0 6px 20px rgba(255, 215, 0, 0.4)';
                            }}
                            onMouseLeave={(e) => {
                                e.target.style.transform = 'translateY(0)';
                                e.target.style.boxShadow = '0 4px 15px rgba(255, 215, 0, 0.3)';
                            }}
                        >
                            {loading ? 'Signing In...' : 'Sign In'}
                        </button>
                    </div>
                </div>

                {/* Links */}
                <div className="mobile-login-footer">
                    <p className="mobile-login-text" style={{ fontSize: '0.9rem', color: 'rgba(255, 255, 255, 0.7)' }}>
                        Don't have an account?{' '}
                        <Link to="/mobile/register" style={{ color: '#FFA500', textDecoration: 'underline' }}>
                            Register here
                        </Link>
                    </p>
                    <p className="mobile-login-text" style={{ fontSize: '0.9rem', color: 'rgba(255, 255, 255, 0.7)', marginTop: '0.5rem' }}>
                        <Link to="/mobile/forgotpassword" style={{ color: '#FFA500', textDecoration: 'underline' }}>
                            Forgot your password?
                        </Link>
                    </p>
                </div>
            </form>
            </div>
        </div>
    );
};

export default LoginMobile; 
